import { Availability, DayNumber } from 'apps/Ops/MenuSchedulePage/types'
import differenceInHours from 'date-fns/differenceInHours'
import differenceInMinutes from 'date-fns/differenceInMinutes'

export const getNextAvailableIn = (
  laterDate: Date | number,
  earlierDate: Date | number
): number[] => {
  const hours = differenceInHours(laterDate, earlierDate)
  const minutes = differenceInMinutes(laterDate, earlierDate) % 60

  return [hours, minutes]
}

const daysMap = {
  1: 'Mon',
  2: 'Tues',
  3: 'Wed',
  4: 'Thurs',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun'
} as const

export const getAvailableTimes = (
  availabilities:
    | {
        dayOfWeek: keyof typeof daysMap
        startTime: string
        endTime: string
      }[]
    | null
): string[] | null => {
  if (!availabilities) {
    return null
  }
  return availabilities.map((availability) => {
    return `${daysMap[availability.dayOfWeek]} ${availability.startTime} - ${
      availability.endTime
    }`
  })
}

export const getNextAvailableMessage = (
  laterDate: Date | number,
  soonerDate: Date | number
): string => {
  const hoursAndMinutes = getNextAvailableIn(laterDate, soonerDate)

  const hours = hoursAndMinutes[0]
  const minutes = hoursAndMinutes[1]
  let hoursWord = 'hour'
  let minutesWord = 'minute'
  if (hours > 1) {
    hoursWord = 'hours'
  }
  if (minutes > 1) {
    minutesWord = 'minutes'
  }
  if (hours === 0) {
    return `Next available in  ${minutes} ${minutesWord}`
  }
  if (minutes === 0) {
    return `Next available in ${hours} ${hoursWord}`
  }

  return `Next available in ${hours} ${hoursWord} and ${minutes} ${minutesWord}`
}

export function getModifierOptionsText(
  min: number,
  max: number
): string | undefined {
  if (min > 0 && max > 1) {
    return `choose from ${min} up to ${max} options`
  }
  if (min === 0 && max > 1) {
    return `choose up to ${max} options`
  }
  if (min > 0 && max === 0) {
    return `choose at least ${min} options`
  }
  if ((min === 0 && max === 1) || (min === 1 && max === 1)) {
    return `choose 1`
  }
}

export const daysOfWeek = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday'
} as const

export function createAvailabilityAccumulator() {
  return Object.keys(daysOfWeek).reduce((acc, dayNumber) => {
    acc[dayNumber as DayNumber] = []
    return acc
  }, {} as Record<DayNumber, Availability[]>)
}

export const weekdayToIndex = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7
} as const
